import React, { Component } from 'react'
import {connect} from "react-redux"
import {retrieveStoreDetails, book, clearBook} from "../../actions/storeActions"
import {addToast} from "../../actions"
import {ajaxerrmsg} from "../../actions/http"
import rechargeicon from "../../assets/images/recharge.svg";
import {Link, Redirect} from "react-router-dom"
import NumberFetch from './numberfetch';
import ButtonLoader from "../btnloader";

class StoreCount extends Component {

    state = {
        count: 0
    }

    componentDidMount(){
        this.props.retrieveStoreDetails();
    }

    handlePlus = () => {
        let {data} = this.props.details;
        if(data){
            if(data.available_order > this.state.count){
                this.setState(prevState => {
                    return {
                        count: prevState.count + 1,
                    }
                })
            }
        }
    }

    handleMinus = () => {
        if(this.state.count > 0){
            this.setState(prevState => {
                return {
                    count: prevState.count - 1
                }
            })
        }
    }

    bookNow = () => {
        let {count} = this.state;
        this.props.book({count});
    }

    render() {
        let {fetching, data} = this.props.details;
        if(this.props.storeBook.data){
            return <Redirect to="/orders" />
        }
        return (
            <div className="flex-center store-count flex-column relative">
                <div className="recharge">
                    <Link title="recharge / topup" to="/packages" replace={true} className="btn btn-recharge btn-primary btn-round">
                        <img src={rechargeicon} height="20" alt="" />
                    </Link>
                </div>
                <h1 className="orders-left-count">
                    {
                        fetching ?
                        <NumberFetch /> : data ?
                        data.available_order - this.state.count : 0
                    }
                </h1>
                <h3>Orders Left</h3>
                {
                    fetching ? null : data && data.available_order > 0 ?
                    <>
                        <div className="flex-center m-t-10">
                            <button onClick={this.handleMinus} className="add-round-btn">-</button>
                            <h4 className="m15">{this.state.count}</h4>
                            <button onClick={this.handlePlus} className="add-round-btn f26">+</button>
                        </div>
                        <div className="m-t-30 w40p">
                            <button 
                                disabled={this.state.count && !this.props.storeBook.fetching ? false : true} 
                                className="btn btn-ouja btn-block"
                                onClick={this.bookNow}
                            >
                                {this.props.storeBook.fetching ? <ButtonLoader /> : 'Book Now'}
                            </button> 
                        </div>
                    </>
                    : 
                    <div className="m-t-10">
                        <Link to="/packages" replace={true} style={{padding: `8px 30px`}} className="btn btn-ouja btn-block">Recharge / Topup <span><img src={rechargeicon} height="15" alt="" /></span></Link>
                    </div>
                }
            </div>
        )
    }

    componentDidUpdate(prevProps){
        if(this.props.storeBook.error && !prevProps.storeBook.error){
            this.props.addToast(ajaxerrmsg(this.props.storeBook.error), false);
        }
    }

    componentWillUnmount(){
        this.props.clearBook();
    }
}


const mapStateToProps = ({storeDetails, storeBook }) => ({
    details: storeDetails,
    storeBook
})

const mapDispatchToProps = {
    retrieveStoreDetails, book, clearBook, addToast
}

export default connect(mapStateToProps, mapDispatchToProps)(StoreCount)
